import { createAction, props } from "@ngrx/store";

const prefix = "[Delete Skill]";

export const requestDeleteSkill = createAction(
  `${prefix} Request Delete Skill`,
  props<{ skillId: string }>(),
);
